
import { ReactNode, createContext, useState } from 'react'


const ProfileContext = createContext({});

export const ProfileProvider = ({ children }: { children: ReactNode }) => {
    const [profileOpen, setProfileOpen] = useState<boolean>(false);

    const value = { profileOpen, setProfileOpen };

    return (
        <ProfileContext.Provider value={value}>
            {children}
        </ProfileContext.Provider>
    )
}

export default ProfileContext
